function generateQrCode(settings) {
    if (settings && settings.dialogId) {
        if (settings.server === "wss://localhost") {
            settings.server = `wss://${window.location.host}`;
        }
        return JSON.stringify(settings);
    }
    return null;
}

export default generateQrCode;
